<template>
  <div>
  
    <b-row v-show="true">
      <b-col>
        <b-tabs
          v-model="seltab"
          @click="changeTab"
        >
          <b-tab
            active
          >
            <template #title>
              <feather-icon icon="ServerIcon" />
              <span>Severs</span>
            </template>
            <b-card-code
              class="submain styled"
              title="Servers"
            >
              <servers
                :servers="servers"
                :computing="computing"
                type="downstream"
              />
            </b-card-code>
          </b-tab>
          <b-tab
            :disabled="(!hasServer)"
            :active="(hasServer)"
          >
            <template #title>
              <feather-icon icon="CheckSquareIcon" />
              <span>Master Variables</span>
            </template>
            <b-card-code
              title="Master Variables"
              class="submain styled"
            >
            
              <b-row>
                <b-col md="12">
                  <block-input
                    v-for="item in masterVariables"
                    :key="item.name"
                    :data="item"
                    :value="masterValues[item.name]"
                    :disabled="computing"
                    :model-options="modelOptions"
                    :server="server"
                    :user="1"
                    category="downstream"
                    @genVariable="generateVariable"
                  />
                </b-col>
              </b-row>
            </b-card-code>

          </b-tab>
          <b-tab
            :disabled="!(hasServer && master)"
            :active="(hasServer && master)"
          >
            <template #title>
              <feather-icon icon="MenuIcon" />
              <span>Dependent Variables</span>
            </template>
            <b-card-code
              title="Dependent Variables"
              class="submain styled"
            >
              <b-row>
                <b-col md="12">
                  <block-input
                    v-for="item in dependentVariables"
                    :key="item.name"
                    :data="item"
                    :value="dependentValues[item.name]"
                    :disabled="computing"
                    :model-options="[]"
                    :server="server"
                    :user="1"
                    category="downstream"
                    @genVariable="generateVariable"
                  />
                </b-col>
              </b-row>
            </b-card-code>

          </b-tab>
           <!----
          <b-tab
            v-show="false"
            :disabled="!(hasServer && master && dependent)"
            :active="(hasServer && master && dependent)"
          >
            <template #title>
              <feather-icon icon="GridIcon" />
              <span>Marker list selection</span>
            </template>
            <b-overlay
              :show="!downstream_computed"
              opacity="0.95"
              rounded="md"
            >
              <template
                v-slot:overlay
              >
                <div
                  v-if="downstream_computing || downstream_tmp_computing"
                  style="display:flex; align-items: center; flex-direction: column;"
                >
                  <b-spinner
                    style="width: 4rem; height: 4rem;"
                  />
                  <div class="mt-1">
                    Computing...<br>
                    <small>Last Update: {{ progressDate }}</small>
                  </div>
                </div>
                <b-button
                  v-if="!downstream_computing && !downstream_tmp_computing"
                  variant="outline-primary"
                  class="rounded"
                  size="md"
                  @click="preprocess"
                >
                  DATA NORMALIZATION AND SAMPLING
                </b-button>
              </template>
              <b-card-code
                title="Marker list selection"
                class="submain styled"
              >
                <b-button
                  variant="primary"
                  class="rounded"
                  size="sm mb-1"
                  style="position: absolute;  top: 18px;  background: white;  right: 20px;"
                  @click="RePreprocess"
                >
                  DATA NORMALIZATION AND SAMPLING
                </b-button>
       
                
              </b-card-code>
            </b-overlay>
          </b-tab>
         <b-tab
            v-show="false"
            :disabled="!(hasServer && master && dependent && viewerVersion !== null)"
            :active="(hasServer && master && dependent && viewerVersion !== null && viewerVersion_done === -1 && dr !== 5)"
          >
            <template #title>
              <feather-icon icon="ListIcon" />
              <span>Annotation Viewer </span>
            </template>
            <b-card-code
              :title="'Annotation Viewer' + versionName"
              class="submain styled"
            >
              <results
                :version="viewerVersion"
                :task-status="status"
                @hasImages="getHasImages"
                @addDr="clickDR"
              />
            </b-card-code>
          </b-tab>-->
          <b-tab
            ref="dr_tab"
            
            :disabled="!(hasServer && master && dependent)"
            :active="dr === 5"
            @click="clickDR"
          >
            <template #title>
              <feather-icon icon="CpuIcon" />
              <span>Digital Reconstruction</span>
            </template>
            
            <b-card-code
              :title="'Digital Reconstruction' + versionName"
              class="submain styled"
            >
           
            <digital-list
                  :selected="hasPipeline"
                  :preprocess="downstream_computed"
                  :status="status"
                  :project_id="project_id"
                  :show_data="(seltab == 3? 1 : 0)"
                  @selversion="selVersion"
                  ref="digitalListRef"
                />
           
           <!---- <digital-reconstruction
                :version="1"
                :update="dr"
              />-->
            </b-card-code>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col
        v-if="1 === 2"
        lg="3"
        md="12"
      >
        <b-card-code
          title="Progress"
          class="progress-card"
          no-body
        >
          <b-badge variant="light-warning badge-status">
            calculating
          </b-badge>ntime="runtime"
          />
          <div
            class="output"
          >
            <div
              v-for="(item, index) in outputs"
              :key="'text'+index"
            > {{ item }}</div>
          </div>
        </b-card-code></b-col>
    </b-row>
    <b-card
      no-body
      class="ds-tabs"
    >


      <b-col style="flex-grow:0; right: 0; display: flex;" >
        <b-button
       
          variant="primary"
          size="sm"
          class="mt-1"
          left:0
      
          @click="add_parent_node"
        >
          ADD PARENT NODE 
        </b-button>
      </b-col>
      <b-col class="selecting">
   
        <v-select
              v-model="show_diagrams"
              :multiple="true"
              :options="show_name_options"
              placeholder="Show hierarchy"
              :searchable="true"
              @update="init_show_diagram"
              style="width: 300px; margin-right:1px;min-height: 37px;"
            />
      </b-col>
      <b-row style="padding-bottom:10px">
          <b-col :md="12" style="margin-left:10px">
            <b-row>
              <b-col
              v-for="(data1,index) in data_versions_show"
                :key="index"
                :md="12"
                
             
              >
              <tree-node :md="is_unique" :parentVersion="[parent_version_id]" :data="data1" :allow_data="checkInitialSettings()" ></tree-node>
         

              </b-col>
            </b-row>
          </b-col>
      </b-row>

     






 

    </b-card> 
  </div>
</template>
<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BRow, BCol, BBadge, BTabs, BTab, BOverlay, BSpinner, BButton, BCard
} from 'bootstrap-vue'
import store from '@/store/index'
import axios from 'axios'
import BlockInput from './components/blockInputs.vue'
import servers from './servers.vue'
import markerList from './markerList.vue'
import digitalList from './digitalList.vue'
import results from './tabs/project/downstream/Results.vue'
import digitalReconstruction from './tabs/project/DigitalReconstruction/Digital.vue'
import NewParentNode from './downstream/NewParentNode.vue'
import HierachyNodes from './downstream/HierarchyNodes.vue'
import vSelect from 'vue-select'
import HorizontalScroll from 'vue-horizontal-scroll'
import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css'
import TreeNode from './downstream/TreeNode.vue'
import toast from 'vue-toast'



const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BCardCode,
    toast,
    digitalList,
    TreeNode,
    HorizontalScroll,
    HierachyNodes,
    vSelect,
    BCard,
    BRow,
    BCol,
    BBadge,
    BTabs,
    BTab,
    BButton,
    BlockInput,
    servers,
   markerList ,
    results,
    BOverlay,
    BSpinner,
    digitalReconstruction,
    Multiselect
},
  data() {
    return {
      parent_version_id:{},
      node_number:[1, 2, 3],
      project_id:0,
      show_diagrams:[],
      md_data: 12,
      is_unique: true,
      actionClicked:'',
      do_actions: ['Do split', 'Do noseque'],
      seltab: 0,
      servers: [],
      masterVariables: [],
      dependentVariables: [],
      masterValues: {},
      dependentValues: {},
      projectName: '',
      projectOwner: '',
      projectVisibility: '',
      projectDescription: '',
      computing: false,
      taskProgress: 0,
      cpu: 0,
      ram: 0,
      runtime: '00:00:00',
      outputs: [],
      computeDisabled: true,
      show_name_options: [],
      nodes: [],
      timer: null,
      dependent: false,
      master: false,
      hasServer: false,
      hasPipeline: false,
      pipeline: [],
      progressDate: '',
      waitting: false,
      computingIndex: 0,
      firstCharge: true,
      modelOptions: [],
      log: [],
      server: '',
      user: 0,
      viewerVersion: null,
      downstream_computed: false,
      downstream_computing: false,
      downstream_tmp_computing: false,
      vName: '',
      hasImages: false,
      dr: 0,
      status: [],
      is_unique:true,
      data_versions_show: [],
      data_versions: [],
      
    }
  },
  computed: {
    ready() {
      if (this.master === true && this.dependent === true && this.hasServer === true && this.hasPipeline === true) {
        return true
      }
      return false
    },
    versionName() {
      return (this.vName !== '') ? `: ${this.vName}` : ''
    },
    viewerVersion_done() {
      return (this.viewerVersion !== null) ? this.viewerVersion.done : -1
    },
  },
  watch: {
    show_diagrams: function(value){
      this.init_show_diagram()
    },
    
    
   
  },
  async mounted() {
    
    this.project_id = Number(this.$route.params.id)
   this.getData()
 
    this.init_show_diagram()
    await this.getInputs()
    await this.getStatus( true)
      this.getProgress()

    
     // this.getStatus()
     // this.getProgress()
  
    this.dr = (this.viewerVersion_done > -1) ? this.dr + 1 : 0
    if(this.data_versions.length > 1){
      this.md_data = 6;
      this.is_unique = false;
  
    }
    this.getNodes_init()
   this.getNodes()

    this.timer = setInterval(() => {
      
      if(this.$route.name == 'Downstream Analysis'){
        this.getNodes()
        this.getStatus()
      }
      
   
    }, 1000)
    
   
  },
  destroyed() {},
  beforeDestroy() {
    //clearInterval(this.timer)
  },
  methods: {
  changeTab(){
    console.log("NEW TAB", this.seltab)
  },
    init_show_diagram(){
     
      var new_json = []
      for(var i=0; i< this.data_versions.length;i++){
        if(this.show_diagrams.includes(this.data_versions[i]['hier_name'])){
          new_json.push(this.data_versions[i])

        }
      }
      this.data_versions_show = new_json
      if(this.data_versions_show.length > 1){
      this.md_data = 6;
      this.is_unique = false;
  
    }
    else{
      this.md_data = 12;
    }

    },
 
    async add_parent_node(){
      if(this.checkInitialSettings(true)){
        const project_id = this.$route.params
      const newParent = new Vue({
        ...NewParentNode,
        parent: this,
        propsData: { project_id: project_id, parent_id:0},
      }).$mount()
      this.$swal({
        html: newParent.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        confirmButtonText: 'Save',
        width: '40%',

      }).then(async result => {
          if (result.dismiss == undefined) {
        
          }
        })

      }
   
    },
    

    RePreprocess() {
      this.$swal({
        title: 'Are you sure?',
        text: "All data generated will be deleted. You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'YES',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.preprocess(true)
        }
      })
    },
    preprocess(force = false) {
      if (this.dependent && this.downstream_computed !== 1) {
        this.version = null
        const { id } = this.$route.params
        axios.post(`${url}:${port}/downstream-preprocess/${id}`, { user: 1, force }, { headers }).then(result => {
          this.downstream_computing = true
          this.downstream_tmp_computing = true
        })
      }
    },
    resetversion() {
      this.viewerVersion = null
    },
    getNodes_init(){
     
     const { id } = this.$route.params
     var parent_version_id = {}
     axios.get(`${url}:${port}/downstream-get-nodes/${id}`, { headers }).then(presult => {
       const { nodes } = presult.data
       var final_data = []
       for(var i=0;i< nodes.length;i++){
         if(nodes[i].parent_id == 0){
           this.show_name_options.push(nodes[i].hier_name)
           var new_data = nodes[i]
           nodes[i]['class'] = ["rootNode"]
           final_data.push(new_data)
         }

       }
       var final_data2 = final_data
       for(var j=0;j< nodes.length;j++){
        if(nodes[j].parent_id != 0){
          var parent_id = nodes[j].parent_id
          for(var i=0;i< final_data.length;i++){
            if(
              final_data[i].id == parent_id
            ){
              
              var temp_data = nodes[j]
              for(var x=0; x < nodes.length; x++){
                if(
                  nodes[x].parent_id == temp_data.id
                ){
                  try{
                    temp_data['children'].push(nodes[x])
                  }

                  catch{
                    temp_data['children'] = [nodes[x]]
                  }
                  try{
                parent_version_id[String(parent_id)].push()
              }
              catch{
                parent_version_id[String(parent_id)] = [temp_data.parent_version_id]
              }
    
                }
              }
              try{
                final_data2[i]['children'].push(temp_data)
              }catch{
                final_data2[i]['children'] = [temp_data]
              }
              try{
                parent_version_id[String(parent_id)].push()
              }
              catch{
                parent_version_id[String(parent_id)] = [temp_data.parent_version_id]
              }
              

            }
          }

        }
       }
       this.parent_version_id = parent_version_id
       this.show_diagrams = this.show_name_options;
       this.data_versions = final_data2
       this.data_versions_show = final_data2
       this.init_show_diagram()
       this.data_versions_show = final_data2
     })

   },
   
    getNodes(){
     
      const { id } = this.$route.params
     axios.get(`${url}:${port}/downstream-get-nodes/${id}`, { headers }).then(presult => {
       const { nodes } = presult.data
       var final_data = []
       for(var i=0;i< nodes.length;i++){
         if(nodes[i].parent_id == 0 && this.show_diagrams.includes(nodes[i].hier_name)){
           //this.show_name_options.push(nodes[i].name)
           var new_data = nodes[i]
           nodes[i]['class'] = ["rootNode"]
           final_data.push(new_data)
         }

       }
       var final_data2 = final_data
      
       for(var j=0;j< nodes.length;j++){
        if(nodes[j].parent_id != 0){
          var parent_id = nodes[j].parent_id
          for(var i=0;i< final_data.length;i++){
            if(
              final_data[i].id == parent_id
            ){
              var temp_data = nodes[j]
              for(var x=0; x < nodes.length; x++){
                if(
                  nodes[x].parent_id == temp_data.id
                ){
                  try{
                    temp_data['children'].push(nodes[x])
                  }

                  catch{
                    temp_data['children'] = [nodes[x]]
                  }
                  
                }
              }
              try{
                final_data2[i]['children'].push(temp_data)
              }catch{
                final_data2[i]['children'] = [temp_data]
              }
              
            }
          }
        }
          
       }
       //this.show_diagrams = this.show_name_options;
       this.data_versions = final_data2
       this.data_versions_show = final_data2
       this.init_show_diagram()
       this.data_versions_show = final_data2
     })

    },
    getData() {
      const { id } = this.$route.params
      axios.get(`${url}:${port}/project/${id}`, { headers }).then(presult => {
        const { data, visibility } = presult.data
        if (data.length > 0) {
          const project = data[0]
          const users = visibility
          const uvis = []
          this.projectName = project.name
          this.projectOwner = project.owner
          this.projectDescription = project.description
          store.commit('title', project.name)
          store.commit('icon', 'GridIcon')
          store.commit('isProject', true)
          store.commit('isExperimental', false)
          store.commit('activeSec', 'downstream')
          if (users !== undefined) {
            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < users.length; index++) {
              const element = users[index]
              uvis.push((`${element.name} ${element.lastname}`).trim())
            }
          }
          this.projectVisibility = uvis.join(', ')
        } else {
          this.$router.push({ name: 'Projects' })
        }
      })
    },
    async getInputs( ) {
      const { id } = this.$route.params
      const masterVariables = []
      const masterValues = {}
      const dependentVariables = []
      const dependentValues = {}
      await axios.get(`${url}:${port}/variables/${id}_downstream`, { headers }).then(result => {
        const { data } = result.data
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          if (element.auto === 0 && element.visible === 1) {
            element.original_name = element.name
            const name = (element.name === 'cores') ? 'number_of_cpus' : element.name
            element.name = name
            masterVariables.push(element)
            masterValues[name] = element.value
          } else if (element.auto === 1 && element.visible === 1) {
            element.original_name = element.name
            dependentVariables.push(element)
            dependentValues[element.name] = element.value
          }
        }
        this.masterVariables = masterVariables
        this.dependentVariables = dependentVariables
        this.masterValues = masterValues
        this.dependentValues = dependentValues
      })
   
    },
    generateVariable(data) {
      if (data.input.type === 0 && data.input.visible === 1) {
        this.masterVariables[data.input.name] = data.value
      } else if (data.input.auto === 1 && data.input.visible === 1) {
        this.dependentValues[data.input.name] = data.value
        this.saveVariable(data.input.name, data.value)
      }
    },
    saveVariable(input, value) {
      const category = 'downstream'
      const data = JSON.stringify({ project: this.$route.params.id, value, category })
      axios.put(`${url}:${port}/project_variable/${input}`, data, { headers }).then(async result => {
        console.log(result)
      })
    },
    getHasImages(data) {
      this.hasImages = data
    },
    async getStatus(is_initial = false) {
      const { id } = this.$route.params
     await axios.get(`${url}:${port}/downstream_status/${id}`, { headers }).then(result => {
        console.log(result)
        const {
          dependent, master, hasServer, hasPipeline, status, downstream_computed,
        } = result.data.data
        console.log(hasServer)
        this.status = result.data
        const { log } = result.data
        this.log = log
        this.master = master
        this.dependent = dependent
        this.hasServer = hasServer
        this.server = result.data.data.server_id
        this.hasPipeline = hasPipeline
        this.servers = result.data.servers.servers
        this.pipeline = result.data.data.pipeline
        // eslint-disable-next-line camelcase
        this.downstream_computed = downstream_computed
        if(is_initial){
          this.checkInitialSettings(true)
        }
       
     
        if (this.firstCharge === true) {
          if (status === 1) {
            this.computing = true
          } else {
            this.computing = false
          }
          this.firstCharge = false
        }

      })
      
    },
    showSettingWarning(){
      var warning_info = 'Please, select a server and choose a project/experimental folder to continue.'
      this.$swal({
        title: 'Missing configuration',
        text: warning_info,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          return false
        }
      })
    },
    checkInitialSettings(display_warning = false){

       

      if(this.hasServer == false || this.masterValues['project_folder'] == undefined || this.masterValues['exp_design_path'] == undefined  || this.masterValues['project_folder'] == null || this.masterValues['exp_design_path'] == null  || this.masterValues['project_folder'] == '' || this.masterValues['exp_design_path'] == '') {
        if(display_warning){
          this.showSettingWarning()
        }
       
        return false;
        
      }
      else{
        return true
      }
   
     

    },
    getProgress() {
      if (this.master && this.dependent && this.downstream_computed !== 1) {
        const { id } = this.$route.params
        axios.get(`${url}:${port}/downstream-progress/${id}`, { headers }).then(result => {
          if (result.data.progress !== undefined && result.data.progress !== null) {
            if (result.data.progress.timestamp !== '') {
              this.progressDate = result.data.progress.timestamp
            }
            this.downstream_computing = true
          } else {
            this.downstream_computing = false
          }
        })
      }
    },
    compute() {
      this.computing = true
      this.computingIndex += 1
      const { id } = this.$route.params
      const data = { pipeline: JSON.parse(this.pipeline), user_id: 1 }
      console.log(data)
      axios.post(`${url}:${port}/compute/${id}`, JSON.stringify(data), { headers })
    },
    stop() {
      this.computing = false
      this.computingIndex += 1
      const { id } = this.$route.params
      axios.post(`${url}:${port}/stop-compute/${id}`, JSON.stringify({}), { headers })
    },
    abort() {
      this.computing = false
      this.computingIndex += 1
      const { id } = this.$route.params
      axios.post(`${url}:${port}/abort-compute/${id}`, JSON.stringify({}), { headers })
    },
    clickDR() {
      this.seltab = 5
      this.dr = Date.now()
      console.log('dr', this.dr)
    },
    confirm(type) {
      let confirmBtn = 'Yes, stop it!'
      let confirmTitle = 'Stopped!'
      let confirmText = 'The process has been stopped.'
      if (type === 'abort') {
        confirmBtn = 'Yes, abort process!'
        confirmText = 'The process has been aborted.'
        confirmTitle = 'Aborted!'
      }
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: confirmBtn,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          if (type === 'abort') {
            this.abort()
          } else {
            //this.stop()
          }
          this.$swal({
            icon: 'success',
            title: confirmTitle,
            text: confirmText,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    selVersion(version) {
      this.seltab = 4
      this.viewerVersion = version
      this.vName = version.title
     

    },
  },
}
</script>
<style>
.process-head{
  background:#008380;
  color: #fff;
  font-weight: 600;
}
.list-group .list-group-item.process-head:hover{
  background:#008380;
  color: #fff;
  font-weight: 600;
}
.checkIcon{
  stroke: green !important;
  font-size: 30px ;
}
#chart{
  height:580px!important;
}
.btn-algorithm {
opacity: 0.5;
}
.btn-compute, .badge-status{
    position: absolute;
    right: 20px;
    top: 20px;
}
.progress-card .card-header .card-title{
    color: #5e58733f!important;
}
.output{
        margin: 20px 10px 30px;
    height: 250px;
    border-radius: 10px;
    background-color: #3B3D48;
    border: none;
    padding: 20px;
    font-family: monospace;
    color: #fff;
    font-size: initial;
}
#position {
     display: none !important;
}
#svg {
    background-image: unset
}
#svg text{
   font-size: 10px!important;
}
.connectorText{
  font-size: 10px!important;
}
</style>
<style lang="css">
.card{
 border-radius: 10px!important;
}
.selecting .vs__selected {
    background-color: #008380;
    color:white !important;
}
.styled .card-header{
  background-color: #028380;
  margin-bottom:20px;
  border-radius: 10px 10px 0px 0px !important;
}
.styled .card-header h4{
  color: #fff;
}
.main .card-header{
  background-color: #028380;
}
.main .card-header h4{
  color: #fff;
}
.submain .card-header{
  background-color: #0283807d;
}
.submain .card-header h4{
  color: #000;
}
span.tag {
    background-color: #0283807d;
    border-radius: 5px;
    padding: 2px 10px;
    margin-right: 5px;
    color: white;
    font-weight: 600;
}
.Vue-Toastification__toast {
  background-color: #0283807d;
  min-height: 150px;
  min-width: 150px;
  border-radius: 10px;
  border:1px solid black;
  color:black;
}

span.tag svg{
    margin-right: 5px;
}
p.list {
    margin-bottom: 10px;
}
.div-container{
min-height: calc(100vh - 325px);
}


  .ds-tabs {
    background-color: white;
    min-height: calc(100vh - 700px); 
    height: fit-content;
  /* min-height: 80vh;*/
  
  }
</style>
